import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import func from "./FunctionsAdd";
import validate from "validate.js";
import Modal from "./Modals";


const schema = {
    Ticket: {
        presence: { allowEmpty: false, message: "es requerido" },
        format: {
            pattern: /^(\d{17}|\d{11})$/,
            message: "tiene un formato incorrecto",
        },
    },
    Monto: {
        presence: { allowEmpty: false, message: "es requerido" },
        format: {
            pattern: /^-?\d+(?:.\d+)?$/,
            message: "tiene un formato incorrecto",
        },
    }
};
export default function FindTicket() {
    console.dir(window.location.search);
    const [onModal, setOnModal] = useState(false);
    const [onTypeModal, setOnTypeModal] = useState('ticketInvoiced');
    const ShowLoader = () => { setOnTypeModal("loader"); setOnModal(true); };
    const history = useHistory();
    const ticketRef = useRef();
    const montotRef = useRef();
    const [formState, setFormState] = useState({
        isValid: false,
        values: {},
        touched: {},
        errors: {},
    });
    let modalMsg = onModal ? (<Modal setOnModal={setOnModal} type={onTypeModal} data={""} />) : ("");
    useEffect(() => {
        const errors = validate(formState.values, schema);
        setFormState((formState) => ({
            ...formState,
            isValid: errors ? false : true,
            errors: errors || {},
        }));
    }, [formState.values]);
    useEffect(() => {
        if (window.location.search) {
            let ticket = window.location.search.split("ticket=")[1];
            console.log(ticket);
            findTicketUrl(ticket);
        }
    }, []);
    const handleChange = (event) => {
        event.persist();
        setFormState((formState) => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]: event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true,
            },
        }));
    };
    const showHelp = () => { setOnTypeModal("ayuda"); setOnModal(true); };
    const needHelp = () => { setOnTypeModal("helpContact"); setOnModal(true); }
    const goHome = () => { history.goBack(); };
    const findTicket = async () => {
        ShowLoader();
        let newtcketUrl
        let params = { ticket: ticketRef.current.value, importe: montotRef.current.value }
        //debugger;
        let resjson = await func.EjectFecth("buscaTicket", params);
        debugger
        //Simular respuesta para no vpn
        //  let resjson = { "responseStatusCode": 1, "tkts": [{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null }] }
        if (ticketRef.current.value.length == 11) {
            newtcketUrl = resjson.newTicket
        }
        setOnModal(false);
        switch (resjson.responseStatusCode) {
            case 1://Ok    
                var path = {
                    pathname: '/generarticket',
                    state: { tks: resjson.tkts, ticket: ticketRef.current.value.length == 11 ? newtcketUrl : ticketRef.current.value, importe: resjson.montoSoli, fpago: resjson.fPago, tokenP: resjson.tokenP },
                }
                history.push(path)
                break;
            case 2://Facturado previamente
                setOnTypeModal("ticketInvoiced");
                setOnModal(true);
                break;
            case 3://No encontrado
                setOnTypeModal("ticketNotFound");
                setOnModal(true);
                break;
            case 4:
                setOnTypeModal("ticketConGisftCard");// es de una giftCard
                setOnModal(true);
                break;
            case 5:

                // setOnTypeModal("giftCard");
                // setOnModal(true);

                var path = {
                    pathname: '/generarticket',
                    state: { tks: resjson.tkts, ticket: ticketRef.current.value, importe: resjson.montoSoli, fpago: resjson.fPago, gisftCard: resjson.giftCard },
                }
                history.push(path)
                break;
        }

    };
    const findTicketUrl = async (ticket) => {
        ShowLoader();
        let params = { ticket: ticket, importe: "" }
        //debugger;
        let resjson = await func.EjectFecth("buscaTicket", params);

        //Simular respuesta para no vpn
        //  let resjson = { "responseStatusCode": 1, "tkts": [{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null },{ "WGTSCALE": "0", "ITEMCODE": "80044328509  ", "XTNDPRICE": 492, "DESCRIPCION": "WH GF SENIOR CHICKEN CAT 5.4KG", "AMTIVA": 67.86, "TIPOIVA": "3", "CPNGRPCP": "999", "CPNGRPPP": "000", "IVAIDSAT": "002", "TASAOCUOTAIVA": "0.16", "TIPOFACTORIVA": "Tasa", "ENTQTY": 1, "CLAVEPRODSERV": "10121804", "CLAVEUNIDAD": "H87", "TIPOIEPS": "0", "AMTIEPS2": 0, "IEPSIDSAT": null, "TASAOCUOTAIEPS": null, "TIPOFACTORIEPS": null }] }

        setOnModal(false);
        debugger;
        switch (resjson.responseStatusCode) {
            case 1://Ok    
                var path = {
                    pathname: '/generarticket',
                    state: { tks: resjson.tkts, ticket: resjson.newTicket, importe: resjson.montoSoli, fpago: resjson.fPago, tokenP: resjson.tokenP },
                }
                history.push(path)
                break;
            case 2://Facturado previamente
                setOnTypeModal("ticketInvoiced");
                setOnModal(true);
                break;
            case 3://No encontrado
                setOnTypeModal("ticketNotFound");
                setOnModal(true);
                break;
            case 4:
                setOnTypeModal("ticketConGisftCard");// es de una giftCard
                setOnModal(true);
                break;
            case 5:

                // setOnTypeModal("giftCard");
                // setOnModal(true);

                var path = {
                    pathname: '/generarticket',
                    state: { tks: resjson.tkts, ticket: ticketRef.current.value, importe: resjson.montoSoli, fpago: resjson.fPago, gisftCard: resjson.giftCard, tokenP: resjson.tokenP },
                }
                history.push(path)
                break;
            case 6:
                setOnTypeModal("ticketNotFoundTw");//respuesta de Tw
                setOnModal(true);
                break
        }

    };
    return (
        <>
            {modalMsg}
            <section class="contenido">
                <article id="left-info">
                    <div class="logo-azul">
                        <img src="img/IMG_LOGO_AZUL.png" class="logo-blue" />
                    </div>
                    <div class="contenido-accion">
                        <p class="titulo-accion">Por favor escriba el número de ticket</p>
                        <div class="contenido-column">
                            <div class="numero-ticket">
                                <div class="icon-num">
                                    <img src="img/icon-archive.png" class="icon-archive" />
                                </div>
                                <div class="texto-num">
                                    <input
                                        placeholder="Número de ticket o ID facturación"
                                        class="num-ticket"
                                        ref={ticketRef}
                                        onChange={handleChange}
                                        value={formState.values.Ticket || ""}
                                        type="number"
                                        name="Ticket"
                                    />
                                </div>
                                <div class="question" onClick={showHelp}>?</div>
                            </div>
                            <div class="numero-ticket">
                                <div class="icon-num">
                                    <p class="texto-importe">Importe $</p>
                                </div>
                                <div class="texto-num">
                                    <input
                                        placeholder="0.00"
                                        class="num-ticket"
                                        ref={montotRef}
                                        onChange={handleChange}
                                        value={formState.values.Monto || ""}
                                        type="number"
                                        name="Monto"
                                    />
                                </div>
                                <div class="question1" ></div>
                            </div>
                            <div class="btn-contenido">
                                <button class="regresar" onClick={goHome}>REGRESAR</button>
                                <button class="enviar" onClick={findTicket} disabled={!formState.isValid}>ENVIAR</button>
                            </div>
                        </div>
                    </div>
                    <div class="help">
                        <div class="question3" onClick={showHelp}>?</div>
                        <p class="texto-help" onClick={needHelp}>¿Necesitas ayuda?</p>
                    </div>
                </article>
                <article id="right-img">
                    <div class="img-info"></div>
                </article>

            </section>
        </>
    );
}
// }
